import React, { useState } from "react";
import { Box, Typography, Button, Alert } from "@mui/material";
import { MuiOtpInput } from 'mui-one-time-password-input';
import LoadingPopup from "../../LoadingPopup/LoadingPopup";
import ContactPopup from "../../ContactPopup/ContactPopup";
import { useDispatch } from 'react-redux';
import { resendEmailVerification } from "../../../redux/slices/resendEmailVerification";
const OtpValidation = ({ customerName, taxId, formData, phoneNumberSupport, handleBack, handleConfirm, t, direction, phoneNumber, otpMessage }) => {
  const [otp, setOtp] = useState("");
  // console.log("otpMessage",otpMessage);

  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showLoadingPopup, setShowLoadingPopup] = useState(false);
  const [showContactPopup, setShowContactPopup] = useState(false);
  const [otpResent, setOtpResent] = useState(false);
  const [otpResendError, setOtpResendError] = useState("");

  const dispatch = useDispatch();

  const handleOtpChange = (value, phoneNumber) => {
    setOtp(value);
    if (error) setError("");
  };
  const validateOtp = () => {
    if (otp.length !== 6 || isNaN(otp)) {
      setError(t.otpError);
      return;
    }

    setIsSubmitting(true);
    setShowLoadingPopup(true);

    setTimeout(() => {
      if (otp === otpMessage) {
        handleConfirm(otp);
        // console.log("otpMessage",otpMessage);

        // 939860
        setShowLoadingPopup(false);
      } else {
        // console.log(t.invalidOtp);
        setError(t.invalidOtp);
        setIsSubmitting(false);
        setShowLoadingPopup(false);
      }
    }, 3000);
  };
  const otpMessageInfo = t.otpInfo.replace("{phoneNumber}", phoneNumber);
  return (
    <Box
      sx={{
        textAlign: "center",
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",

      }}

    >
      {/* Title: Account Verification */}
      <Typography
        sx={{
          fontSize: "24px",
          fontWeight: 600,
          lineHeight: "28.13px",
          marginBottom: 2,
          color: "#12538B"
        }}
      >
        {t.accountVerification}
      </Typography>

      {/* Subheading: OTP Info */}
      <Typography
        sx={{
          fontSize: "16px",
          fontWeight: 400,
          lineHeight: "18.75px",
          marginBottom: 2,
          color: "#3F3D3D99",
          whiteSpace: 'pre-line', // Allows the text to break into multiple lines
        }}
      >
        {otpMessageInfo}
      </Typography>


      {/* OTP Input Fields (6 digits) */}
      <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
        <MuiOtpInput
          value={otp}
          onChange={handleOtpChange}
          length={6}
          sx={{
            display: "flex",
            gap: "10px",
            '& .MuiOtpInput-input': {
              width: '40px',
              height: '40px',
              fontSize: '24px',
              textAlign: 'center',
              textTransform: 'uppercase',
              border: '2px solid #ccc',
              borderRadius: '8px',
              outline: 'none',
              transition: 'border-color 0.3s ease',
              '&:focus': {
                borderColor: '#007bff',
              },
            },
          }}
        />
      </Box>
      {/* Success message after OTP resend */}
      {otpResent && (
        <Typography sx={{ color: "green", fontSize: "14px", marginTop: 1 }}>
          {t.otpResentSuccess} {/* This would be your success message */}
        </Typography>
      )}

      {/* Error message after OTP resend */}
      {otpResendError && (
        <Typography sx={{ color: "red", fontSize: "14px", marginTop: 1 }}>
          {otpResendError} {/* This will display any error message */}
        </Typography>
      )}
      {/* Error message */}
      {error && (
        <Typography sx={{ color: "red", fontSize: "14px", marginTop: 1 }}>
          {error}
        </Typography>
      )}

      {/* Buttons */}
      <Box sx={{ display: "flex", justifyContent: "center", marginTop: "16px", width: "100%" }}>
        <Button
          variant="contained"
          onClick={validateOtp}
          sx={{
            backgroundColor: "#0D4975",
            fontSize: "16px",
            fontWeight: 600,
            textTransform: "none",
            padding: "10px 20px",
            width: "200px",
            opacity: isSubmitting ? 0.6 : 1,
          }}
        // disabled={isSubmitting}
        >
          {isSubmitting ? t.verifying : t.submit}
        </Button>
      </Box>

      {/* Resend OTP */}
      <Typography
        sx={{
          fontSize: "16px",
          fontWeight: 400,
          lineHeight: "18.75px",
          textAlign: "center",
          marginTop: 2,
          color: "#12538B",
          direction
        }}

      >
        {t.resendOtp}{" "}
        <Button
          variant="text"
          type="button"
          sx={{
            fontSize: "16px",
            fontWeight: 400,
            color: "#797979",
            padding: 0,
            "&:hover": {
              textDecoration: "underline",
            },
          }}
          onClick={() => {
            dispatch(resendEmailVerification({ customerName, phoneNumber, taxId }))
              .unwrap() // .unwrap() to handle successful or failed dispatch
              .then((data) => {
                if (data.successtate === 200) {
                  setOtpResent(true);  // Set OTP resent status to true on success
                  setOtpResendError("");
                  setTimeout(() => setOtpResent(false), 3000);
                } else {
                  setOtpResent(false); // In case of failure
                  setOtpResendError(data.errormessage || t.otpResendFailed);
                  setTimeout(() => setOtpResendError(false), 3000);
                }
              })
              .catch((error) => {
                setOtpResent(false); // In case of error in the dispatch
                setOtpResendError(t.otpResendFailed);
                setTimeout(() => setOtpResendError(false), 3000);
              });
          }}
        >
          {t.Resend}
        </Button>
      </Typography>

      {/* Show the LoadingPopup if the state is true */}
      {showLoadingPopup && (
        <LoadingPopup
          message={t.pleaseWait}
          onContactSupport={() => setShowContactPopup(true)}
          t={t}
        />
      )}
      <ContactPopup
        open={showContactPopup}
        onClose={() => setShowContactPopup(false)}
        t={t}
        phoneNumberSupport={phoneNumberSupport}
      />

    </Box>
  );
};

export default OtpValidation;